import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;

  @media ${sizes.tabletLandscape} {
    flex-direction: row;
  }
  @media ${sizes.desktop} {
    flex-direction: column;
  }
  @media ${sizes.largeDesktop} {
    flex-direction: row;
  }
`;

export const ElectronicsRestriction = styled.div`
  position: relative;
  max-width: 240px;
  padding: 10px;
  border-radius: 8px;
  background-color: ${th('colors.darkPictonBlue')};
  color: ${th('colors.white')};

  > p {
    margin-top: 4px;
    color: ${th('colors.transparentWhite.7')};
  }
`;

export const ElectronicsHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ElectronicsIllustration = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 8px;
  margin-right: 10px;
  background-color: ${th('colors.turquoise')};
  box-shadow: ${th('shadows.small')};

  > img {
    width: 75%;
    height: auto;
  }
`;
